import {Table} from "@devexpress/dx-react-grid-material-ui";
import {withStyles} from "@material-ui/core/styles";
import React from "react";
import {tableStyle} from "../../../utils/tables";

const TableComponentBase = ({ classes, ...restProps }) => (
	<Table.Table
		{...restProps}
		className={classes.tableHeader}
	/>
);

export const TableComponent = withStyles(tableStyle, { name: 'TableComponent' })(TableComponentBase);


export const Row = ({ tableRow, onDoubleFunc, ...restProps }) => {
	const handleDoubleClick = () => {
		if(tableRow.row === undefined) return;
		if(onDoubleFunc) onDoubleFunc(tableRow.row);
	};

	const isHighLight = (tableRow.row !== undefined) ? (tableRow.row.isHighLight === "1") : false;
	const isHighLight2 = (tableRow.row !== undefined) ? (tableRow.row.isHighLight2 === "1") : false;
	const isDeleted = (tableRow.row !== undefined) ? (tableRow.row.isDeleted === "1") : false;

	const isColorY = (tableRow.row !== undefined) ? (tableRow.row.isColorY === "1") : false;
	const isColorM = (tableRow.row !== undefined) ? (tableRow.row.isColorM === "1") : false;
	const isColorC = (tableRow.row !== undefined) ? (tableRow.row.isColorC === "1") : false;
	const isColorG = (tableRow.row !== undefined) ? (tableRow.row.isColorG === "1") : false;

	let classNames = '';
	if(isColorY){
		classNames = 'isColorY'
	}
	else if(isColorM){
		classNames = 'isColorM'
	}
	else if(isColorC){
		classNames = 'isColorC'
	}
	else if(isColorG){
		classNames = 'isColorG'
	}
	else if(isDeleted){
		classNames = 'isDeleted'
	}
	else if(isHighLight2){
		classNames = 'isHighLight2'
	}
	else if(isHighLight){
		classNames = 'isHighLight'
	}

	return (
		<Table.Row
			{...restProps}
			className={classNames}
			onDoubleClick={handleDoubleClick}
		/>
	);
};



// WEBPACK FOOTER //
// ./src/common/components/table/components/table-components.js